/**
 * 企业集采本地存储：采购车与收货地址簿均保存在 localStorage（免登录采购）
 * 购物车条目：{ productId, skuId, number, name, skuName, mainImage, price, procureMinNumber }
 * procureMinNumber 为企业集采起购量（商品维度，可为空表示不限制），随详情页加购写入，用于结算页校验
 */

const KEY_CART = "selection2_purchase_cart";
const KEY_ADDRESS = "selection2_purchase_address";

function read(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (e) {
    return fallback;
  }
}

function write(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function notify() {
  try {
    window.dispatchEvent(new CustomEvent("purchase-cart-changed"));
  } catch (e) {
    /* ignore */
  }
}

/* ============================== 采购车 ============================== */

export function getCart() {
  return read(KEY_CART, []);
}

export function cartCount() {
  return getCart().reduce((sum, k) => sum + (k.number || 0), 0);
}

export function addToCart(item) {
  const list = getCart();
  const exist = list.find((k) => k.skuId === item.skuId);
  if (exist) {
    exist.number += item.number || 1;
  } else {
    list.push({ ...item, number: item.number || 1 });
  }
  write(KEY_CART, list);
  notify();
  return list;
}

export function updateCartNumber(skuId, number) {
  const list = getCart().map((k) => (k.skuId === skuId ? { ...k, number } : k));
  write(KEY_CART, list);
  notify();
  return list;
}

export function removeFromCart(skuIds) {
  const ids = Array.isArray(skuIds) ? skuIds : [skuIds];
  const list = getCart().filter((k) => !ids.includes(k.skuId));
  write(KEY_CART, list);
  notify();
  return list;
}

/* ============================== 地址簿 ============================== */

export function getAddressList() {
  return read(KEY_ADDRESS, []);
}

export function saveAddress(address) {
  const list = getAddressList();
  if (address.id) {
    const idx = list.findIndex((k) => k.id === address.id);
    if (idx > -1) {
      list.splice(idx, 1, address);
    }
  } else {
    address.id = `addr_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    list.push(address);
  }
  write(KEY_ADDRESS, list);
  return address;
}

export function removeAddress(id) {
  const list = getAddressList().filter((k) => k.id !== id);
  write(KEY_ADDRESS, list);
  return list;
}

export function setDefaultAddress(id) {
  const list = getAddressList().map((k) => ({ ...k, isDefault: k.id === id }));
  write(KEY_ADDRESS, list);
  return list;
}

export function getDefaultAddress() {
  const list = getAddressList();
  return list.find((k) => k.isDefault) || list[0] || null;
}
